export const CC_DETECT_REGEX = /\b\d(?:[ _-]?\d){12,18}\b/g;
